import api from "../config";

export const pdfAPI = {
  generatePDF: async (type, formData) => {
    const response = await api.post(
      "/vehiculesneuf/pdf/generate",
      {
        type,
        formData,
      },
      {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  },

  getFieldsDetails: async (pdfType) => {
    const { data } = await api.get("/vehiculesneuf/pdf/fields", {
      params: { type: pdfType },
    });
    return data;
  },
};
